export const CSOSN_SINIEF_URL =
  'https://www.confaz.fazenda.gov.br/legislacao/ajustes/sinief/a03_10';

export const CSOSN_GOLDEN_TRIBUTADA_COM_CREDITO = '101';
export const CSOSN_GOLDEN_SEM_CREDITO = '102';
export const CSOSN_GOLDEN_ST = '201';
export const CSOSN_GOLDEN_ICMS_ANTERIOR = '500';
export const CSOSN_CODE_COUNT = 10;
